<template>
	<div class="d-flex-between-center p-d-16">
		<div class="f-regular f-16 f-c-midgrey">
			<span v-html="title"></span>
			<span v-if="actionText !== ''" v-html="actionText" @click="action"></span>
		</div>
		<div class="f-semi f-16 f-c-blue" @click="filter" v-if="showFilter">
			Filter
			<img src="../../../../src/assets/icons/filter.svg" alt="" v-if="appliedFilter === 0">
			<span class="filter-count" v-if="appliedFilter > 0">
				{{ appliedFilter }}
			</span>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
	name: "SOHeaderList",
	props: {
		title: String,
		showFilter: Boolean,
		actionText: String
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		})
	},
	data() {
		return {
			appliedFilter: 0,
		}
	},
	watch: {
		filterItem: {
			handler: function () {
				this.countAppliedFilter()
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		filter(payload) {
			this.$emit("filter", payload)
		},
		action(payload) {
			this.$emit("action", payload)
		},
		countAppliedFilter() {
			this.appliedFilter = 0
			for (let f in this.filterItem) {
				if (f === "sorting") {
					continue;
				}
				if (Array.isArray(this.filterItem[f])) {
					if (this.filterItem[f].length > 0) {
						this.appliedFilter++
					}
				}
				if (typeof this.filterItem[f] === "string") {
					if (this.filterItem[f] === "0") {
						continue
					}
					if (this.filterItem[f] !== "") {
						this.appliedFilter++
					}
				}
			}
			if (this.filterItem.periode.filterBy !== "") {
				this.appliedFilter++
			}
      if (this.filterItem.akunBiayaItemBiaya.idbiaya && this.filterItem.akunBiayaItemBiaya.iditemBiaya) {
				this.appliedFilter++
      }
		}
	}
}
</script>

<style scoped>
.filter-count {
	border-radius: 4px;
	background-color: #206CFF;
	color: white;
	padding: 2px 4px;
}
</style>